import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { AccordionItemContextProvider } from "@/components/General/Faq/context/accordionItem.context";
import { useFaqContext } from "@/components/General/Faq/context/faq.context";
import { useMapped } from "@/context/mapped.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const AccordionItem = ({ className, children }: Props) => {
    const { selection } = useFaqContext();
    const { index } = useMapped();

    const question = selection.category.faqQuestions[index];
    const open = question.alias === selection.question?.alias;

    return (
        <AccordionItemContextProvider
            question={question}
            open={open}
        >
            <div className={cn(className)}>{children}</div>
        </AccordionItemContextProvider>
    );
};
